import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Spinner } from '../../../components/Spinner/spinner';

export default () => {
  const history = useHistory();
  const { user, isInitialized, authLoading } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user?._id) history.push('/tickets');
  }, [user]);

  return <>{(!isInitialized || authLoading) && <Spinner />}</>;
};
